import React from 'react';
import { NumberInput } from 'react-admin';
import Heading from 'components/Heading';
import { getInherited } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import type { InheritedSettingsT } from '../types/inheritedSettings.types';

type FeesInputsProps = {
  settingsField: string;
  inheritedSettings: InheritedSettingsT;
};

export const FeesInputs = ({ settingsField, inheritedSettings }: FeesInputsProps) => {
  return (
    <>
      <Heading>Fees</Heading>
      <NumberInput
        label="Cancellation Fee Window"
        source={`${settingsField}.cancellation_fee_window`}
        helperText={getInherited(inheritedSettings, 'cancellation_fee_window')}
      />
      <NumberInput
        label="Cancellation Fee Charge Hours"
        source={`${settingsField}.cancellation_fee_charge_hours`}
        helperText={getInherited(inheritedSettings, 'cancellation_fee_charge_hours')}
      />
      <NumberInput
        label="Agency VMS Fee Percent"
        source={`${settingsField}.agency_vms_fee_percent`}
        helperText={getInherited(inheritedSettings, 'agency_vms_fee_percent')}
      />
    </>
  );
};
